import '../style/Header.css'
import logo from '../images/logo better.svg'
import { Link } from 'react-router-dom'
import { useState } from "react";

export function Header() {
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className="head_container">
            <div className="logo_box">
                <Link to="/" className="logo_box_link">
                    <img className="logo" src={logo} alt="Tincisioni" />
                </Link>
            </div>

            {/* HAMBURGER ICON */}
            <div 
                className="menu_icon" 
                onClick={() => setMenuOpen(!menuOpen)}
            >
                ☰
            </div>

            {/* MENU */}
            <div className={`menu_box ${menuOpen ? "active" : ""}`}>
                <div className="link_box">
                    <Link to="/marcature industriali" className="menu_box_link" onClick={() => setMenuOpen(false)}>
                        Marcature Industriali
                    </Link>
                </div>
                <div className="link_box">
                    <Link to="/personalizza" className="menu_box_link" onClick={() => setMenuOpen(false)}>
                        Personalizza
                    </Link>
                </div>
                <div className="link_box">
                    <Link to="/invia un immagine" className="menu_box_link" onClick={() => setMenuOpen(false)}>
                        Invia un immagine
                    </Link>
                </div>
            </div>
        </div>
    );
}